import * as React from "react";
import { FieldPath, FieldValues, useController } from "react-hook-form";
import { PdsrStateType } from "./PdsrStateType";
import StateAsChip from "../../../../Layout/StateChip/ActivityStateAsChip";
import { ActivityState } from "../../../../Layout/StateChip/ActivityState";
import { RhfInputProps } from "../../../../Forms/RhfInputProps";

export default function PdsrStateAsChip<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({ name }: RhfInputProps<TFieldValues, TName>) {
  const {
    field,
    formState: { disabled: isFormDisabled },
  } = useController({
    name,
  });

  const getActivityState = (state: PdsrStateType): ActivityState => {
    switch (state) {
      case PdsrStateType.Active:
        return "Active";
      case PdsrStateType.Expired:
        return "Expired";
      case PdsrStateType.New:
        return "New";
      default:
        throw new Error(`PdsrState getActivityState not implemented for ${state}`);
    }
  };

  return (
    <StateAsChip
      {...field}
      activityState={getActivityState(field.value)}
      disabled={isFormDisabled}
    />
  );
}
